<template>
	<b-container
		id="app"
		fluid
		v-bind:class="{ 'login-bg': showBackground }"
	>
		<component :is="layout">
			<router-view />
		</component>

	</b-container>

</template>

<script>
const default_layout = "default";

export default {
	name: "App",

	components: {},

	computed: {
		layout() {
			return (this.$route.meta.layout || default_layout) + "-layout";
		},

		showBackground() {
			switch (this.$route.name) {
				case "home":
				case "login":
				case "reset":
					return true;
					break;

				default:
					return false;
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/App.vue